export default __webpack_public_path__ + "static/media/logo-talent-developer.314c5a4a.svg";